module.exports = __webpack_public_path__ + "ng.svg?f9abfac27e4762fa325182457abfeb5f";